import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CACHE_KEY = "ruta360_products_cache";
const TTL = 24 * 60 * 60 * 1000;
const TIMEOUT = 8000;
const RETRY_DELAYS = [1000, 2000];

let products = [];
let loaded = false;
let error = false;
let running = false;
const listeners = new Set();

const readCache = () => {
  try {
    const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || "null");
    if (cached && Array.isArray(cached.data) && Date.now() - cached.ts < TTL) {
      return cached.data;
    }
  } catch {
    /* sin caché */
  }
  return null;
};

const cachedData = readCache();
if (cachedData && cachedData.length > 0) {
  products = cachedData;
  loaded = true;
}

const notify = () => listeners.forEach((l) => l());

const fetchProducts = () => {
  if (running) return;
  running = true;
  error = false;
  const attempt = (n) => {
    const preloaded = n === 0 && typeof window !== "undefined" && window.__R360_PRODUCTS;
    const req = preloaded
      ? window.__R360_PRODUCTS.then((data) => ({ data }))
      : axios.get(`${API}/products`, { timeout: TIMEOUT });
    req
      .then((r) => {
        products = r.data;
        loaded = true;
        error = false;
        running = false;
        try {
          localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), data: r.data }));
        } catch {
          /* sin espacio */
        }
        notify();
      })
      .catch(() => {
        if (n < RETRY_DELAYS.length) {
          setTimeout(() => attempt(n + 1), RETRY_DELAYS[n]);
        } else {
          running = false;
          if (!loaded) {
            error = true;
            notify();
          }
        }
      });
  };
  attempt(0);
};

export const retryProducts = () => {
  running = false;
  notify();
  fetchProducts();
};

export const useProducts = () => {
  const [, force] = useState(0);
  useEffect(() => {
    const listener = () => force((n) => n + 1);
    listeners.add(listener);
    fetchProducts();
    return () => listeners.delete(listener);
  }, []);
  return { products, loaded, error };
};
